'use strict';

exports.__esModule = true;
var html = document.getElementsByTagName('html')[0];
var lang = html.getAttribute('lang') || 'en_US';
var locale = lang.replace('_', '-');
var User = {
	getLocale: function getLocale() {
		return locale;
	}
};

exports['default'] = User;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** /jobvolume/donatenodeweb-ci-9488/workspace/Release/~/react-i18n/dist/user.js
 ** module id = 177
 ** module chunks = 0 1 2 3 4 5 6
 **/